@use '../../scss/utility';

:host {
  display: block;
}

:host([active]) {
  pointer-events: none;
}

.item {
  padding: 0;
  margin-inline-end: var(--wb-spacing-3xs);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  text-decoration: none;
  min-width: utility.wb-pixel-to-rem(24px);
  height: utility.wb-pixel-to-rem(48px);

  @include utility.breakpoint-to(mq5) {
    margin-inline-end: 0;
  }

  &:last-child {
    .item-inner {
      margin-inline-end: 0;
    }
  }

  &:focus-visible {
    outline: utility.wb-pixel-to-rem(1px) solid var(--wb-blue-45);
  }
}

.item-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--wb-radius-s);
  min-width: utility.wb-pixel-to-rem(24px);
  height: utility.wb-pixel-to-rem(20px);
  color: var(--wb-grey-85);
}

:host([active]) {
  pointer-events: none;

  .item {
    outline: none;
  }

  .item-inner {
    background-color: var(--wb-grey-15);
    color: var(--wb-white);
  }
}
